var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m58.667 128 74.666-117.333L208 128l-74.667 42.667z",
    fill: "#daa89f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.333 10.667 208 128l-74.667 42.667z",
    fill: "#cb8679"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m58.667 144 74.666 42.667L208 144l-74.667 101.333z",
    fill: "#daa89f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.333 186.667 208 144l-74.667 101.333zM58.667 128l74.666-32L208 128l-74.667 42.667z",
    fill: "#cb8679"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.333 96 208 128l-74.667 42.667z",
    fill: "#c06b5c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthRed);
export default __webpack_public_path__ + "static/media/ETHRed.c04fe20e9e672a5b3fe9c7d7c70f7fab.svg";
export { ForwardRef as ReactComponent };